import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AgencyLayout from '../layouts/AgencyLayout';
import ClientLayout from '../layouts/ClientLayout';
import PublicLayout from '../layouts/PublicLayout';
import AgencyRoutes from './agency/AgencyRoutes';
import ClientRoutes from './client/ClientRoutes';
import RequireAuth from './guards/RequireAuth';
import RequireRole from './guards/RequireRole';
import LoginPage from '../features/auth/LoginPage';
import RegisterPage from '../features/auth/RegisterPage';
import ForgotPasswordPage from '../features/auth/ForgotPasswordPage';
import ResetPasswordPage from '../features/auth/ResetPasswordPage';
import SSOCallbackPage from '../features/auth/SSOCallbackPage';

const AGENCY_ROLES = ['agency-admin', 'operator', 'viewer', 'agency'];
const CLIENT_ROLES = ['client'];

function AppRoutes() {
  return (
    <Routes>
      {/* Auth screens — reachable only while anonymous (handled inside). */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/sso/:provider" element={<SSOCallbackPage />} />

      {/* Agency persona (flat routes are the decided shape; /agency/* is
          aspirational spec — see frontend-tasks.md T21.4). */}
      <Route
        element={(
          <RequireAuth>
            <RequireRole roles={AGENCY_ROLES}>
              <AgencyLayout />
            </RequireRole>
          </RequireAuth>
        )}
        path="/"
      >
        <Route element={<AgencyRoutes />} path="*" />
      </Route>

      {/* Client persona — white-labeled portal. */}
      <Route
        element={(
          <RequireAuth>
            <RequireRole roles={CLIENT_ROLES}>
              <ClientLayout />
            </RequireRole>
          </RequireAuth>
        )}
        path="/client"
      >
        <Route element={<ClientRoutes />} path="*" />
      </Route>

      {/* Public marketing shell (T14 will fill it; keep the route discoverable). */}
      <Route element={<PublicLayout />} path="/welcome">
        <Route index element={<Navigate replace to="/login" />} />
      </Route>

      <Route element={<Navigate replace to="/approvals" />} path="*" />
    </Routes>
  );
}

export default AppRoutes;
